export const MAIN_CLASS_NAME = 'agent-relation-table';
export const PAGINATION_ROW_CLASS_NAME = `${MAIN_CLASS_NAME}__pagination-row`;
export const CELL_CLASS_NAME = `${MAIN_CLASS_NAME}__cell`;
